import React from "react";

// A lot's result as inglis.com.au's lot page shows it (owner, 26 Sep 2026): a
// "Sale Result" card with the sold amount, purchaser and purchaser location; a
// passed-in horse shows its reserve and never a price (DECISIONS.md, 18 Sep 2026);
// a withdrawn horse gets a banner instead of a card.

const money = value => `$${Number(value).toLocaleString("en-AU")}`;

export const isWithdrawn = (horse, result) => Boolean(horse?.withdrawn) || result?.status === "WITHDRAWN";

/** One line for a horse card, or null before the horse has been through the ring. */
export function resultLine(result) {
  if (result?.status === "SOLD") {
    return [`Sold ${result.price != null ? money(result.price) : ""}`.trim(), result.purchaser].filter(Boolean).join(" · ");
  }
  if (result?.status === "PASSED_IN") {
    return result.reserve != null ? `Passed in · Reserve ${money(result.reserve)}` : "Passed in";
  }
  return null;
}

export function WithdrawnBanner() {
  return <p className="lot-withdrawn" role="status">Lot withdrawn</p>;
}

export function SaleResult({ result }) {
  const rows = result?.status === "SOLD"
    ? [["Sold amount", result.price != null ? money(result.price) : "Not published"],
      ["Purchaser", result.purchaser], ["Purchaser location", result.purchaserLocation]]
    : result?.status === "PASSED_IN"
      ? [["Reserve", result.reserve != null ? money(result.reserve) : "Not published"]]
      : null;
  if (!rows) return null;
  const title = result.status === "SOLD" ? "Sale result" : "Sale result: Passed in";
  return <section className={`sale-result ${result.status === "SOLD" ? "sold" : "passed-in"}`} aria-label="Sale result">
    <h3>{title}</h3>
    <dl>
      {rows.filter(([, value]) => value).map(([label, value]) =>
        <React.Fragment key={label}><dt>{label}</dt><dd>{value}</dd></React.Fragment>)}
    </dl>
  </section>;
}
